<template lang="pug">
  div
    header
      main-header(
        :notificacao="false"
        :hasListagemModelo="false"
      )
    app-modal-adicionar-assinatura(
      v-if="showModalAdicionarAssinatura"
      :assinaturaEditando="assinaturaEditando"
      @closeModal="closeModal"
    )
    el-image(
      v-if="imageSrc"
      ref="previewImage"
      :src="imageSrc"
      :preview-src-list="[imageSrc]"
      fit="contain"
      style='width: 190px; height: 130px'
      @close="onPreviewClose"
    )
    .content-route-view
    el-card(shadow="hover").card
      el-row
        el-col(:span="12")
          h1 Assinaturas
        el-col(:span="12")
          .button
            el-button(
              @click="cadastrar",
              type="success"
            )
              span.center
                i.fa.fa-plus
                span &nbsp Cadastrar
      app-divider(
        label="Listagem de assinaturas cadastradas",
      )
      el-row
        el-table(
          :data="assinaturas"
          empty-text="Não foram encontrados assinaturas cadastradas"
        )
          el-table-column(
            prop="nome",
            align="left",
            label="Nome na assinatura",
          )
          el-table-column(
            prop="cargo",
            align="left",
            label="Cargo",
          )
          el-table-column(
            prop="dataCadastro",
            align="center",
            label="Data de Cadastro"
            :formatter="formatDate"
          )
          el-table-column(
            label='Ações',
            width='120',
            align='center'
          )
            template(slot-scope='scope')
              el-dropdown(trigger="click")
                el-button(type='primary', size="mini")
                  | Ações
                  i.el-icon-arrow-down.el-icon--right
                el-dropdown-menu(slot='dropdown')
                  el-dropdown-item
                    .flex(@click="visualizar(scope.row)")
                      i.fas.fa-eye
                      | &nbsp Visualizar
                  el-dropdown-item
                    .flex(@click="editar(scope.row)")
                      i.fas.fa-edit
                      | &nbsp Editar
                  el-dropdown-item
                    .flex(@click="download(scope.row)")
                      i.fas.fa-download
                      | &nbsp Download
                  el-dropdown-item
                    .flex(@click="excluir(scope.row)")
                      i.fas.fa-trash
                      | &nbsp Excluir

</template>

<script>
import { mapActions } from 'vuex'
import AppDivider from '@/components/AppDivider'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModalAdicionarAssinatura from '@/screens/portal/seguranca/components/AppModalAdicionarAssinatura.vue'
import MainHeader from '@/components/MainHeader.vue'
import axios from '@/utils/api'
import FileSaver from 'file-saver'

export default {
  name: 'AdministrarAssinaturas',

  components: {
    AppDivider,
    MainHeader,
    AppModalAdicionarAssinatura
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      showModalAdicionarAssinatura: false,
      assinaturas: [],
      imageSrc: null,
      assinaturaEditando: null
    }
  },

  async created () {
    this.findAssinatuas()
  },

  mounted () {
    this.ensureWhitePreviewBg()
  },

  methods: {
    ...mapActions({
      findAll: 'assinaturaPdf/findAll',
      downloadDocumento: 'documento/downloadDocumento'
    }),

    async findAssinatuas () {
      this.assinaturas = await this.findAll()
    },

    cadastrar () {
      this.showModalAdicionarAssinatura = true
    },

    closeModal () {
      this.showModalAdicionarAssinatura = false
      this.assinaturaEditando = null
      this.findAssinatuas()
    },

    closeModalVisualiza () {
      this.bytes = null
    },

    async visualizar (item) {
      const blob = await axios({
        method: 'POST',
        url: `documento/file`,
        data: item.documento,
        responseType: 'blob'
      })
      this.imageSrc = URL.createObjectURL(blob)
      if (this.imageSrc) {
        this.$nextTick(() => {
          this.$refs.previewImage.showViewer = true
          this.patchClose()
        })
      }
    },

    async download (item) {
      const blob = await axios({
        method: 'POST',
        url: `documento/file`,
        data: item.documento,
        responseType: 'blob'
      })
      if (blob) {
        FileSaver.saveAs(blob, item.documento.fileName)
      }
    },

    editar (item) {
      this.assinaturaEditando = item
      this.showModalAdicionarAssinatura = true
    },

    excluir (item) {
      this.$confirm('Tem certeza que deseja excluir esta assinatura?', 'Atenção', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        type: 'warning'
      }).then(async () => {
        const response = await axios({
          method: 'DELETE',
          url: `assinatura-pdf/${item.id}`
        })

        if (!response.ok) {
          this.$emit('closeModal')
          this.showNotificacao(
            this.$messages.TIPO_SUCCESS,
            this.$messages.TITULO_SUCCESS,
            'Assinatura excluída com sucesso!'
          )
        }
        this.findAssinatuas()
      })
    },

    onPreviewClose () {
      this.imageSrc = null
    },

    patchClose () {
      const c = this.$refs.previewImage
      if (!c) return

      const fnName = c.closeViewer ? 'closeViewer' : null
      if (!fnName) return

      const original = c[fnName].bind(c)
      c[fnName] = (...args) => {
        this.onPreviewClose()
        return original(...args)
      }
    },

    ensureWhitePreviewBg () {
      if (document.getElementById('white-el-image-preview')) return

      const style = document.createElement('style')
      style.id = 'white-el-image-preview'
      style.textContent = `
        .el-image-viewer__wrapper { background: #fff !important; }
        .el-image-viewer__mask { background: #fff !important; }
        .el-image-viewer__btn { color: #000 !important; }
      `
      document.head.appendChild(style)
    },

    formatDate (row, column, cellValue) {
      if (!cellValue || cellValue.length < 6) return ''

      const [year, month, day, hour, minute, second] = cellValue

      const date = new Date(
        year,
        month - 1,
        day,
        hour,
        minute,
        second
      )

      return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })
    }
  }
}
</script>

<style lang="scss" scoped>

  .card {
    margin: 0 3%;
    border-radius: 10px;
  }

  .button {
    display: flex;
    justify-content: flex-end;
  }

  .flex {
    display: flex;
    align-items: center;
    justify-content: left;
  }

  h1 {
    margin-top: 0px;
    font-size: 24px;
  }

  .lista {
      ul, li {
      margin: 0;
      padding: 0;
      list-style: none;
    }
  }

  .margin-top {
    margin-top: 40px;
  }

  .margin-bottom {
    margin-bottom: 40px;
  }

  .ativo {
    color: #009f61;
  }

</style>



// WEBPACK FOOTER //
// src/screens/portal/seguranca/AdministrarAssinaturas.vue